import { getIsCypressRunning } from "constants/constants";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { camelCaseKeys } from "launchdarkly-react-client-sdk";
import { atom, useAtom } from "jotai";
export const cypressOverridesAtom = atom({});

export const useSyncCypressOverrides = () => {
  const [, setCypressOverrides] = useAtom(cypressOverridesAtom);
  // run when the url changes
  const location = useLocation();
  useEffect(() => {
    if (getIsCypressRunning()) {
      const overrides = window.localStorage.getItem(
        "CYPRESS_LD_FLAG_OVERRIDES"
      );
      const overridesParsed = overrides ? JSON.parse(overrides) : {};
      if (overridesParsed) {
        const overridesCamel = camelCaseKeys(overridesParsed);
        setCypressOverrides(overridesCamel);
      }
    }
  }, [location.pathname, setCypressOverrides]);
};
